/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useToken } from "../hooks/use-token";
import sweetAlert from "../components/sweet-alert";

const AuthContext = React.createContext({
  accessToken: "",
  accessTokenExpiry: "",
  refreshToken: "",
  refreshTokenExpiry: "",
  isLoggedIn: false,

  login: (accessToken, accessTokenExpiry, refreshToken, refreshTokenExpiry) => {
    if ((accessToken, accessTokenExpiry, refreshToken, refreshTokenExpiry))
      return "";
  },
});

export default AuthContext;

export function AuthContextProvider(props) {
  const [token, setToken] = useToken();
  const [refreshToken, setRefreshToken] = useState("");
  const userIsLoggedIn = Boolean(token);
  let sessionExpiryTimer = null;
  let toastTimer = null;
  useEffect(() => {
    //call this function to start timer in case of refresh
    // sessionExpiryTimeHandler();
    if (!token) {
      clearTimeout(sessionExpiryTimer);
      clearTimeout(toastTimer);

      return;
    }
    return () => {
      if (sessionExpiryTimer) {
        clearTimeout(sessionExpiryTimer);
      }
      if (toastTimer) {
        clearTimeout(toastTimer);
      }
    };
  }, []);

  const loginHandler = (
    accessToken,
    accessTokenExpiry,
    refreshToken,
    refreshTokenExpiry,
  ) => {
    sessionStorage.setItem("auth-expiry-time", accessTokenExpiry);
    sessionStorage.setItem("refresh-expiry-time", refreshTokenExpiry);
    sessionStorage.setItem("refresh-token", refreshToken);
    setToken(accessToken);
    setRefreshToken(refreshToken);
    localStorage.setItem("token", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  };

  const logoutHandler = () => {
    if (process.env.REACT_APP_CLIENT !== "CT") {
      sessionStorage.clear();
    }
    window.top.postMessage({ type: "logout" }, process.env.REACT_APP_ADMIN);
  };

  const contextValue = {
    token,
    refreshToken,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
}
